import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { AuditeePermissionDTO } from 'app/model/auditee-permission-dto';

import { SidebarComponent } from 'app/theme/admin-layout/sidebar/sidebar.component';
import { CustomMessages } from '@shared';

import { CommonDTO } from 'app/model/common-dto';
import { ManageAuditProgramDto } from 'app/model/manage-audit-program-dto';
import { CommonService } from 'app/service/common.service';
import { AuditSummaryOutputDto } from 'app/model/audit-summary-output-dto';
import { element } from 'protractor';
import { SiteWiseAuditeeBean } from './../../../model/site-wise-auditee-bean';
import { AuditorAuditeePermissionDeptWiseBean } from './../../../model/auditor-auditee-permission-dept-wise-bean';
import { AuditorAuditeePermissionResponseBean } from './../../../model/auditor-auditee-permission-response-bean';
import { AuditorAuditeeDeptPermissionService } from './../../../service/auditor-auditee-dept-permission-service';
import { MatExpansionPanelHeader, MatSlideToggle } from '@angular/material';

@Component({
  selector: 'app-managepermission',
  templateUrl: './managepermission.component.html',
  styleUrls: ['./managepermission.component.scss'],
})
export class ManagepermissionComponent implements OnInit {
  cities2 = [
    { id: 1, name: 'Vilnius' },
    { id: 2, name: 'Kaunas' },
    { id: 3, name: 'Pavilnys', disabled: true },
    { id: 4, name: 'Pabradė' },
    { id: 5, name: 'Klaipėda' },
  ];
  //variables
  emailIds: string = '';
  selectedCity: any;
  selectedCityIds: string[];
  status: number;
  message: string;
  roleValue: number;
  saveDataRes: any;
  changeFlag: boolean = false;
  dept: Array<any> = [];
  selectedAuditeeEmails: any = [];
  parsedJson: any;
  title: string = '';
  allDeptFlag: boolean = false;
  changeIconColourFlag: boolean = false;
  openSettingsDiv: boolean = false;
  addAllFlag: boolean = true;
  replaceAllFlag: boolean = false;
  deleteFlag: boolean = false;
  selectedAuditeeEmailsFromSettings: any;
  selectedAuditeeEmails2FromSettings: any;
  //DTOs
  commonDTO: CommonDTO = new CommonDTO();
  auditeePermissionDTO: AuditeePermissionDTO = new AuditeePermissionDTO();

  //Getting Values Beans
  siteWiseAuditeeBeanList: SiteWiseAuditeeBean[] = [];
  auditorAuditeePermissionDeptWiseBeanList: AuditorAuditeePermissionDeptWiseBean[] = [];
  auditorAuditeePermissionResponseBeanList: AuditorAuditeePermissionResponseBean[] = [];

  //Sending Values Beans
  auditorAuditeePermissionResponseBean: AuditorAuditeePermissionResponseBean = new AuditorAuditeePermissionResponseBean();
  auditorAuditeePermissionDeptWiseBeanList1: AuditorAuditeePermissionDeptWiseBean[] = [];
  auditorAuditeePermissionResponseBeanList1: AuditorAuditeePermissionResponseBean[] = [];

  noteFlag = false;

  //Input from SummaryPageComponent
  @Input() siteId: string;
  @Input() auditProgramDto: ManageAuditProgramDto;
  @Input() auditProgramId: string;
  @Input() auditSummaryOutputDto: AuditSummaryOutputDto;
  @Input() managePermissionFlag: string;
  @Input() enableAllTransaction: any;

  @Output() closePanelpermission: EventEmitter<boolean> = new EventEmitter();
  @Output() changeIconColour: EventEmitter<boolean> = new EventEmitter();

  @ViewChildren('panelH') panelH: QueryList<MatExpansionPanelHeader>;
  @ViewChildren('toggler') toggler: QueryList<MatSlideToggle>;

  constructor(
    private commonService: CommonService,
    private auditorAuditeeDeptPermissionService: AuditorAuditeeDeptPermissionService,
    private sidebarComponent: SidebarComponent,
    private customMessage: CustomMessages
  ) { }

  ngOnInit() {
    if (this.enableAllTransaction == undefined) {
      this.enableAllTransaction = 1;
    }

    if (this.managePermissionFlag == 'auditee') {
      this.title = 'cams.label.managePermission.defineAuditees';
    } else {
      this.title = 'cams.label.managePermission.defineAuditors';
    }
    this.getSiteAndAuditAreaIdByAuditId()
  }
  parsedJSON: any;
  auditAreaId: any
  getSiteAndAuditAreaIdByAuditId() {

    this.commonDTO.auditId = this.auditProgramId;
    this.commonService.getSiteAndAuditAreaIdByAuditId(this.commonDTO).subscribe(data => {
      this.parsedJSON = JSON.parse(JSON.stringify(data));
      this.siteId = this.parsedJSON[0].siteId;
      this.auditAreaId = this.parsedJSON[0].auditAreaId;
      this.getRoleDeptData();
    }),
      error => {
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      };
  }

  getRoleDeptData() {

    this.sidebarComponent.showHideLoader(true);

    // this.auditeePermissionDTO.auditId = this.auditProgramId;
    // this.auditeePermissionDTO.actionType = 'L';
    // this.auditeePermissionDTO.auditeeIds = "";
    // this.auditeePermissionDTO.siteId = Number(this.auditProgramDto.siteId);
    // this.auditeePermissionDTO.roleType = this.managePermissionFlag;
    // this.auditeePermissionDTO.roleId = 0;

    this.commonDTO.auditProgramId = this.auditProgramId;
    this.commonDTO.actionType = 'L';
    // this.auditeePermissionDTO.auditeeIds = "";
    this.commonDTO.siteId = this.auditProgramDto.siteId;
    this.commonDTO.teamType = this.managePermissionFlag;
    this.commonDTO.roleId = '0';
    let loggedInUserEmail = localStorage.getItem('email');
    let colorChange = false;
    this.commonDTO.auditAreaId = this.auditAreaId;
    this.auditorAuditeeDeptPermissionService
      .getPermissionRoleNDeptList(this.commonDTO)
      .subscribe((data: any) => {
        this.auditorAuditeePermissionResponseBeanList = data;

        this.auditorAuditeePermissionResponseBeanList.forEach(
          (element: AuditorAuditeePermissionResponseBean, i) => {
            element.permissionRoleNDeptWiseBeanList.forEach((elementDept, j) => {
              if (
                this.enableAllTransaction != '1' &&
                elementDept.auditeeUserName != null &&
                elementDept.auditeeUserName.includes(loggedInUserEmail)
              ) {
                elementDept.accessDept = '0';
              } else if (this.enableAllTransaction != '1' && elementDept.auditeeUserName == null) {
                elementDept.accessDept = '0';
              }
              if (elementDept.ncPermissionUsers != '') {
                this.noteFlag = true;
              }
              if (
                elementDept.auditeeUserName == null ||
                elementDept.auditeeUserName == undefined ||
                elementDept.auditeeUserName == ''
              ) {
                this.dept.push({
                  id: j,
                  deptId: elementDept.deptId,
                  deptName: elementDept.deptName,
                  auditeeEmail: [],
                  auditeeUserName: [],
                  accessDept: elementDept.accessDept,
                  ncPermissionUsers: elementDept.ncPermissionUsers,
                });
              } else {
                this.dept.push({
                  id: j,
                  deptId: elementDept.deptId,
                  deptName: elementDept.deptName,
                  auditeeEmail: elementDept.auditeeEmail.split(';'),
                  auditeeUserName: elementDept.auditeeUserName.split(';'),
                  accessDept: elementDept.accessDept,
                  ncPermissionUsers: elementDept.ncPermissionUsers,
                });
              }
            });
            this.dept.forEach(element => {
              if (element.auditeeUserName != '') {
                colorChange = true;
              }
            });

            this.selectedAuditeeEmails.push({
              id: i,
              roleId: element.roleId,
              isRoleMandatory: element.isRoleMandatory,
              dept: this.dept,
              colorChange: colorChange,
            });
            this.dept = [];
            colorChange = false;
          }
        );
      });
    this.sidebarComponent.showHideLoader(false);
  }
  closed() {
    this.closePanelpermission.emit(false);
  }

  saveGridData(roleId) {
    this.sidebarComponent.showHideLoader(true);
    this.auditorAuditeePermissionDeptWiseBeanList1 = [];
    this.auditorAuditeePermissionResponseBeanList1 = [];

    this.selectedAuditeeEmails.forEach((element, i) => {
      if (element.roleId == roleId) {
        this.roleValue = element.roleId;
        element.dept.forEach((elementDept, j) => {
          let auditorAuditeePermissionDeptWiseBean: AuditorAuditeePermissionDeptWiseBean = new AuditorAuditeePermissionDeptWiseBean();

          auditorAuditeePermissionDeptWiseBean.deptName = elementDept.deptName;
          elementDept.auditeeUserName.forEach((x, k) => {
            if (typeof x === 'object' && x != null) {
              this.emailIds += x.auditeeEmail + ';';
            } else {
              var eId: string = x;
              if (eId.includes('(')) {
                var a = eId.indexOf('(') + 1;
                var b = eId.indexOf(')');
                eId = eId.substring(a, b) + ';';
              }
              this.emailIds += eId;
            }
          });
          if (
            auditorAuditeePermissionDeptWiseBean.deptName == 'All' &&
            this.emailIds == '' &&
            element.isRoleMandatory == '1'
          ) {
            this.allDeptFlag = true;
          }
          this.emailIds = this.emailIds.replace(' [Inactive]', '');

          if (
            this.selectedAuditeeEmailsFromSettings != '' &&
            this.selectedAuditeeEmailsFromSettings != undefined
          ) {
            if (this.addAllFlag)
              this.selectedAuditeeEmailsFromSettings.forEach(element => {
                this.emailIds += element.auditeeEmail + ';';
              });

            if (this.deleteFlag) {
              this.selectedAuditeeEmailsFromSettings.forEach(element => {
                if (this.emailIds.includes(element.auditeeEmail)) {
                  this.emailIds = this.emailIds.replace(element.auditeeEmail + ';', '');
                }
              });
            }

            if (this.replaceAllFlag)
              if (this.emailIds.includes(this.selectedAuditeeEmailsFromSettings.auditeeEmail)) {
                this.emailIds = this.emailIds.replace(
                  this.selectedAuditeeEmailsFromSettings.auditeeEmail + ';',
                  this.selectedAuditeeEmails2FromSettings.auditeeEmail + ';'
                );
              }
          }

          this.emailIds = this.emailIds.replace(' [Inactive]', '');

          auditorAuditeePermissionDeptWiseBean.auditeeEmail = this.emailIds;

          this.auditorAuditeePermissionDeptWiseBeanList1.push(auditorAuditeePermissionDeptWiseBean);
          this.emailIds = '';
        });
        this.auditorAuditeePermissionResponseBean.roleId = this.roleValue;
        this.auditorAuditeePermissionResponseBean.permissionRoleNDeptWiseBeanList = this.auditorAuditeePermissionDeptWiseBeanList1;
      }
    });
    this.auditorAuditeePermissionResponseBeanList1.push(this.auditorAuditeePermissionResponseBean);

    this.auditorAuditeePermissionResponseBeanList.forEach(
      (element: AuditorAuditeePermissionResponseBean, i) => {
        if (element.roleId == this.roleValue) {
          element.permissionRoleNDeptWiseBeanList.forEach((elementDept, j) => {
            this.auditorAuditeePermissionDeptWiseBeanList1.forEach(k => {
              if (k.deptName == elementDept.deptName) {
                if (elementDept.auditeeEmail == undefined || elementDept.auditeeEmail == null) {
                  if (k.auditeeEmail != '') {
                    this.changeFlag = true;
                  }
                } else if (k.auditeeEmail == '') {
                  this.changeFlag = true;
                } else if (k.auditeeEmail != elementDept.auditeeEmail + ';') {
                  this.changeFlag = true;
                }
              }
            });
          });
        }
      }
    );

    if (this.allDeptFlag == true) {
      this.sidebarComponent.showHideLoader(false);
      this.customMessage.showErrorMessage('cams.label.managePermission.selectAtleastOnePerson', '');
      this.allDeptFlag = false;
      return false;
    }
    if (
      this.changeFlag == false &&
      (this.selectedAuditeeEmailsFromSettings == '' ||
        this.selectedAuditeeEmailsFromSettings == undefined)
    ) {
      this.sidebarComponent.showHideLoader(false);
      this.customMessage.showErrorMessage('cams.label.common.noChange', '');
      this.closed();
      return false;
    }
    this.selectedAuditeeEmails.forEach(element => {
      element.dept.forEach(k => {
        if (k.auditeeUserName != '') {
          this.changeIconColourFlag = true;
          element.colorChange = true;
        } else {
          element.colorChange = false;
        }
      });
    });

    this.changeIconColour.emit(this.changeIconColourFlag);
    this.auditeePermissionDTO.permissionResponseBeanList = this.auditorAuditeePermissionResponseBeanList1;
    this.auditeePermissionDTO.auditId = this.auditProgramId;
    this.auditeePermissionDTO.actionType = 'U';
    this.auditeePermissionDTO.siteId = Number(this.auditProgramDto.siteId);
    this.auditeePermissionDTO.roleType = this.managePermissionFlag;
    this.auditeePermissionDTO.roleId = this.roleValue;

    this.auditorAuditeeDeptPermissionService
      .updateDeptWisePermission(this.auditeePermissionDTO)
      .subscribe(
        (data: any) => {
          this.saveDataRes = data;
          this.message = this.saveDataRes.p_error_desc;
          this.status = this.saveDataRes.p_status;
          this.sidebarComponent.showHideLoader(false);
          //ERROR
          if (this.status == 0) {
            this.customMessage.showErrorMessage('cams.label.common.updationFailed', '');
          }
          //SUCCESS
          if (this.status == 1) {
            this.customMessage.showSuccessMessage(
              'cams.label.common.operationCompletedSuccessfully'
            );
          }
          //INACTIVE EMAILIDS
          if (this.status == 20) {
            this.customMessage.showErrorMessage(
              'cams.label.common.selectedEmailsInactive',
              this.saveDataRes.emailId
            );
          }
          //DELETED EMAILIDS
          if (this.status == 30) {
            this.customMessage.showErrorMessage(
              'cams.label.common.selectedEmailsDeleted',
              this.saveDataRes.emailId
            );
          }
          //ONE PERSON HAVING MULTIPLE ROLES
          if (this.status == 101) {
            this.customMessage.showErrorMessage('cams.label.common.onePersonMultipleRoles', '');
          }
          if (
            this.selectedAuditeeEmailsFromSettings != '' &&
            this.selectedAuditeeEmailsFromSettings != undefined
          ) {
            this.closed();
          }
        },
        error => {
          this.customMessage.showErrorMessage('cams.label.common.internalErrorOccured', '');
        }
      );
  }

  openSettings(evt) {
    if (evt.checked) {
      this.openSettingsDiv = true;
    } else {
      this.openSettingsDiv = false;
    }
  }

  changeRadioSetting(evt) {
    if (evt.value == 1) {
      this.addAllFlag = true;
      this.replaceAllFlag = false;
      this.deleteFlag = false;
    } else if (evt.value == 2) {
      this.addAllFlag = false;
      this.replaceAllFlag = true;
      this.deleteFlag = false;
    } else if (evt.value == 3) {
      this.addAllFlag = false;
      this.replaceAllFlag = false;
      this.deleteFlag = true;
    }
  }

  toggleAcco() {
    this.toggler.forEach((toggledElement, i) => {
      toggledElement.writeValue(false);
    });
    this.openSettingsDiv = false;
    this.addAllFlag = true;
    this.replaceAllFlag = false;
    this.deleteFlag = false;
  }
}
